import type { SceneSlice, SceneState, ViewerSliceCreator } from "./types";

export const sceneInitialState: SceneState = {
  meshes: {},
  camera: {
    position: [2, 2, 2],
    target: [0, 0, 0],
  },
  backgroundColor: "#ffffff",
  meshToInstance: {},
  lastTransformUpdateTime: 0,
};

export const createSceneSlice: ViewerSliceCreator<SceneSlice> = (set) => ({
  ...sceneInitialState,

  addMesh: (msg) =>
    set((state) => {
      state.meshes[msg.uuid] = {
        uuid: msg.uuid,
        vertices: msg.vertices,
        faces: msg.faces,
        color: msg.color,
        opacity: msg.opacity,
        position: msg.position,
        quaternion: msg.quaternion,
        parent_uuid: msg.parent_uuid,
        instance_id: msg.instance_id,
      };
      // Track mesh to instance mapping
      if (msg.instance_id) {
        state.meshToInstance[msg.uuid] = msg.instance_id;
      }
    }),

  addMeshGlb: (msg) =>
    set((state) => {
      state.meshes[msg.uuid] = {
        uuid: msg.uuid,
        glb_url: msg.glb_url,
        color: msg.color,
        opacity: msg.opacity,
        position: msg.position,
        quaternion: msg.quaternion,
        parent_uuid: msg.parent_uuid,
        instance_id: msg.instance_id,
      };
      // Track mesh to instance mapping
      if (msg.instance_id) {
        state.meshToInstance[msg.uuid] = msg.instance_id;
      }
    }),

  removeMesh: (uuid) =>
    set((state) => {
      delete state.meshes[uuid];
      if (state.selectedMeshUuid === uuid) {
        state.selectedMeshUuid = null;
      }
    }),

  updateTransforms: (updates) =>
    set((state) => {
      for (const update of updates) {
        const mesh = state.meshes[update.uuid];
        if (mesh) {
          mesh.position = update.position;
          mesh.quaternion = update.quaternion;
        }
      }
      // Track when transforms were last updated (for hiding stale markers)
      state.lastTransformUpdateTime = Date.now();
    }),

  setCamera: (position, target) =>
    set((state) => {
      state.camera.position = position;
      state.camera.target = target;
    }),

  setBackgroundColor: (color) =>
    set((state) => {
      state.backgroundColor = color;
    }),
});
